import { t } from "../i18n";
const STORAGE_KEY = "inquiry_products";
let isSentView = false;
let popupQueryTimer = null;

const parseStoredData = (value) => {
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const getStoredItems = () => parseStoredData(localStorage.getItem(STORAGE_KEY));

const setStoredItems = (items) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
};

const sanitizeText = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#x27;");

const syncCheckboxes = () => {
  const storedIds = getStoredItems().map((item) => String(item.id));
  const checkboxes = document.querySelectorAll('[data-inquiry-checkbox]');

  checkboxes.forEach((checkbox) => {
    const productId = checkbox.dataset.productId;
    checkbox.checked = storedIds.includes(String(productId));

    const row = checkbox.closest('.products-table__row');
    if (row) {
      row.classList.toggle('products-table__row--queried', checkbox.checked);
    }
  });
};

const addItem = (item) => {
  const stored = getStoredItems();
  const exists = stored.some((storedItem) => String(storedItem.id) === String(item.id));
  if (exists) {
    return stored;
  }

  const updated = [...stored, item];
  setStoredItems(updated);
  return updated;
};

const removeItem = (id) => {
  const stored = getStoredItems();
  const updated = stored.filter((item) => String(item.id) !== String(id));
  setStoredItems(updated);
  return updated;
};

const clearStoredItems = () => {
  localStorage.removeItem(STORAGE_KEY);
};

const setQueryOpenState = (isOpen) => {
  const query = document.querySelector('.query');
  if (!query) return;

  const overlay = document.querySelector('.overlay');

  query.classList.toggle('query--active', Boolean(isOpen));

  if (overlay) {
    overlay.classList.toggle('overlay--visible', Boolean(isOpen));
  }
};

const showAddedPopup = (title = "") => {
  const popup = document.querySelector('.popup-query');
  if (!popup) return;

  const titleSlot = popup.querySelector('.popup-query__name span');
  if (titleSlot) {
    titleSlot.textContent = title || "";
  }

  popup.classList.add('popup-query--active');

  if (popupQueryTimer) {
    window.clearTimeout(popupQueryTimer);
    popupQueryTimer = null;
  }

  popupQueryTimer = window.setTimeout(() => {
    hideAddedPopup();
    popupQueryTimer = null;
  }, 3000);
};

const hideAddedPopup = () => {
  if (popupQueryTimer) {
    window.clearTimeout(popupQueryTimer);
    popupQueryTimer = null;
  }

  const popup = document.querySelector('.popup-query');
  if (!popup) return;

  popup.classList.remove('popup-query--active');
};

const getSingleProductItem = () => {
  const singleRoot = document.querySelector('.single-regranulaty[data-product-id][data-product-title]');
  if (!singleRoot) return null;

  const id = singleRoot.dataset.productId;
  const title = singleRoot.dataset.productTitle;

  if (!id || !title) return null;

  return { id, title };
};

const syncRegranulateField = (items) => {
  const fields = document.querySelectorAll('.query input[name="regranulates"]');

  if (!fields.length) return;

  const value = items.map((item) => item.title).filter(Boolean).join(', ');

  fields.forEach((field) => {
    field.value = value;
  });
};

const removeFrontPageHeroButtonIfNeeded = (items) => {
  if (!items.length) return;

  const button = document.querySelector('.order-offer');
  if (button) {
    button.remove();
  }
};

const renderQueryItems = () => {
  const container = document.querySelector('.query__items');
  const counter = document.querySelector('.query__counter');
  const headerInfo = document.querySelector('.h-bottom__query-products');
  const headerCounter = document.querySelector('.h-bottom__query-products span');
  const mobileCounter = document.querySelector('.h-top-mobile__query-counter');
  const activeSection = document.querySelector('.query__active');
  const emptySection = document.querySelector('.query__empty');
  const sentSection = document.querySelector('.query__sent');

  const items = getStoredItems();

  syncRegranulateField(items);

  // mobile popup: show only when there's at least 1 item
  const mobilePopup = document.querySelector('.query-mobile-popup');
  if (mobilePopup) {
    const isVisible = items.length > 0;
    mobilePopup.classList.toggle('query-mobile-popup--visible', isVisible);
    mobilePopup.hidden = !isVisible;
    mobilePopup.setAttribute('aria-hidden', String(!isVisible));

    // also toggle a body-level class for global styling when popup is visible
    try {
      document.body.classList.toggle('query-mobile-popup--visible', isVisible);
    } catch (e) {
      // ignore if document.body not available
    }

    let countEl = mobilePopup.querySelector('.query-mobile-popup__count');
    if (!countEl) {
      const productsWrap = mobilePopup.querySelector('.query-mobile-popup__products') || mobilePopup;
      countEl = document.createElement('span');
      countEl.className = 'query-mobile-popup__count';
      productsWrap.appendChild(countEl);
    }
    countEl.textContent = String(items.length);
  }
  removeFrontPageHeroButtonIfNeeded(items);

  if (counter) {
    counter.textContent = String(items.length);
  }

  if (headerCounter) {
    headerCounter.textContent = String(items.length);
  }

  if (mobileCounter) {
    mobileCounter.textContent = String(items.length);
  }

  if (headerInfo) {
    headerInfo.hidden = items.length === 0;
  }

  if (activeSection && emptySection && sentSection) {
    if (isSentView) {
      activeSection.hidden = true;
      emptySection.hidden = true;
      sentSection.hidden = false;
    } else {
      activeSection.hidden = items.length === 0;
      emptySection.hidden = items.length > 0;
      sentSection.hidden = true;
    }
  }

  if (!container) return;

  if (!items.length) {
    container.innerHTML = `<p class="query__empty">${t("queryEmptyProducts", "Brak produktów w zapytaniu.")}</p>`;
    return;
  }

  container.innerHTML = items
    .map(
      (item) => `
      <div class="query__item">
        <label class="query__action">
          <input
            class="checkbox"
            type="checkbox"
            data-inquiry-checkbox
            data-product-id="${sanitizeText(item.id)}"
            data-product-title="${sanitizeText(item.title)}"
            checked
          >
          <span>${sanitizeText(item.title)}</span>
        </label>
      </div>
    `,
    )
    .join('');
};

const initQueryConfirm = () => {
  const modal = document.querySelector('.query-confirm[data-confirm-modal-query]');
  if (!modal) return;

  let pendingAction = null;

  const open = () => {
    modal.hidden = false;
  };

  const close = () => {
    modal.hidden = true;
    pendingAction = null;
  };

  document.addEventListener('click', async (event) => {
    const clearButton = event.target.closest('[data-clear-query]');
    const cancel = event.target.closest('[data-confirm-cancel-query]');
    const confirm = event.target.closest('[data-confirm-ok-query]');
    const overlay = event.target.closest('[data-confirm-close-query]');

    if (clearButton) {
      event.preventDefault();

      pendingAction = async () => {
        clearStoredItems();
        syncCheckboxes();
        renderQueryItems();
      };

      open();
      return;
    }

    if (confirm) {
      await pendingAction?.();
      close();
      return;
    }

    if (cancel || overlay) {
      close();
    }
  });
};

const handleCheckboxChange = (event) => {
  const checkbox = event.target.closest('[data-inquiry-checkbox]');
  if (!checkbox) return;

  const item = {
    id: checkbox.dataset.productId,
    title: checkbox.dataset.productTitle || "",
  };

  if (checkbox.checked) {
    const beforeCount = getStoredItems().length;
    addItem(item);
    const afterCount = getStoredItems().length;

    if (afterCount > beforeCount) {
      showAddedPopup(item.title);
    }
  } else {
    removeItem(item.id);
  }

  const row = checkbox.closest('.products-table__row');
  if (row) {
    row.classList.toggle('products-table__row--queried', checkbox.checked);
  }

  syncCheckboxes();
  renderQueryItems();
};

export const initQuery = () => {
  const checkboxes = document.querySelectorAll('[data-inquiry-checkbox]');

  if (checkboxes.length) {
    syncCheckboxes();
    document.addEventListener('change', handleCheckboxChange);
  }

  initQueryConfirm();
  renderQueryItems();

  // make mobile popup clickable to open full query (same as header/mobile query buttons)
  try {
    const mobilePopupEl = document.querySelector('.query-mobile-popup');
    if (mobilePopupEl && !mobilePopupEl.dataset.queryClickInit) {
      mobilePopupEl.addEventListener('click', (event) => {
        event.preventDefault();
        isSentView = false;
        renderQueryItems();
        setQueryOpenState(true);
        hideAddedPopup();
      });
      mobilePopupEl.dataset.queryClickInit = '1';
    }
  } catch (e) {
    // noop
  }

  document.addEventListener('click', (event) => {
    const popupButton = event.target.closest('.popup-query__button');
    if (popupButton) {
      event.preventDefault();
      isSentView = false;
      renderQueryItems();
      setQueryOpenState(true);
      hideAddedPopup();
      return;
    }

    const addToQueryButton = event.target.closest('.cf7-form__query');
    if (addToQueryButton) {
      event.preventDefault();
      isSentView = false;

      const item = getSingleProductItem();
      if (!item) return;

      const beforeCount = getStoredItems().length;
      addItem(item);
      const afterCount = getStoredItems().length;

      if (afterCount > beforeCount) {
        showAddedPopup(item.title);
      }

      syncCheckboxes();
      renderQueryItems();
      return;
    }

    const openQuery = event.target.closest('.h-bottom__query, .h-top-mobile__query');
    if (openQuery) {
      isSentView = false;
      renderQueryItems();
      setQueryOpenState(true);
      return;
    }

    const close = event.target.closest('.query__close');
    if (!close) return;

    setQueryOpenState(false);
  });

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) {
      isSentView = false;
      syncCheckboxes();
      renderQueryItems();
    }
  });

  window.addEventListener('inquiry:updated', (event) => {
    if (event?.detail?.action === 'add' && event?.detail?.added) {
      showAddedPopup(event.detail.item?.title || "");
    }

    isSentView = false;
    syncCheckboxes();
    renderQueryItems();
  });

  document.addEventListener('wpcf7mailsent', (event) => {
    const queryRoot = document.querySelector('.query');
    if (!queryRoot) return;

    const form = event?.target;
    if (!(form instanceof Element) || !queryRoot.contains(form)) return;

    clearStoredItems();
    isSentView = true;
    syncCheckboxes();
    renderQueryItems();
    setQueryOpenState(true);
  });
};
